import React, { useContext, useEffect, useState } from "react";
import Hamburger from "../Hamburger/Hamburger";
import { ilustration, mainLogo } from "../../helpers/ImagesCache";
import { GlobalContext } from "../../helpers/Context";
import {
  PlatformDesktop,
  PlatformMobile,
  PlatformTablet,
} from "../../helpers/Constants";
import useTranslation from "../../hooks/useTranslation";

// variant advanced, basic, ovace

const Header = ({ variant, minimal, className, simple }) => {
  const globalCtx = useContext(GlobalContext);
  const T = useTranslation();

  return (
    <>
      <div style={styles.main(minimal)} className={className ? className : ""}>
        <div style={styles.container} className="px-6 py-2">
          <div className={`${PlatformMobile ? 'w-3/12' : 'w-2/12'} flex h-full items-center justify-start text-center text-2xl z-[301] relative`}>
            <Hamburger />
          </div>
          <div className={`${PlatformMobile ? 'w-6/12' : 'w-8/12'} flex justify-center z-[199] items-center relative`}>
            <img
              src={mainLogo}
              alt={"LOGO"}
              className={`object-contain h-[40px] ${PlatformMobile ? 'max-w-[120px]' : 'max-w-full'}`}
            />
            {/* label advanced */}
            {variant && (
              <span
                className={`${PlatformMobile ? 'ml-2' : 'ml-4'} rounded p-1 font-bold text-xs`}
                style={{
                  background: variant === "advanced" ? "#C4ECE8" : variant==='basic'?'#DCEEF6':"#FFEFD7",
                }}
              >
                {T(variant)}
              </span>
            )}
          </div>
          <div className={`${PlatformMobile ? 'w-3/12' : 'w-2/12'} flex`}></div>
          {!simple && (
            <div className=" absolute top-0 right-0 z-[198]">
              <img
                src={ilustration}
                alt={"LOGO"}
                className="object-cover h-[150px] z-[198]"
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default Header;

const styles = {
  main: (minimal) => {
    return {
      position: "relative",
      height: "100px",
      justifyContent: minimal ? "center" : "space-between",
      minWidth: PlatformMobile ? "280px" : "330px",
      maxWidth: PlatformTablet ? "100%" : PlatformDesktop ? "1280px" : "700px",
      width: "100%",
      display: "flex",
      background: "#F9FAFB",
      flexDirection: "column",
      overflow: "hidden",
    };
  },
  container: {
    paddingTop: PlatformMobile ? "10px" : "10px",
    paddingBottom: PlatformMobile ? "10px" : "10px",
    paddingRight: PlatformMobile ? "20px" : "20px",
    paddingLeft: PlatformMobile ? "20px" : "20px",
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: PlatformMobile ? "8px" : "0px",
  },
  elements: {
    paddingTop: PlatformMobile ? "10px" : "10px",
    paddingBottom: PlatformMobile ? "10px" : "20px",
    paddingRight: PlatformMobile ? "10px" : "20px",
    paddingLeft: PlatformMobile ? "10px" : "20px",
  },
  ilustracion: {
    width: "auto",
    height: "20vh",
    right: "calc(100% - 1280px)",
  },
};
